/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FeatureFlagEntrySourceEnum } from './FeatureFlagEntrySourceEnum';
import {
  FeatureFlagEntrySourceEnumFromJSON,
  FeatureFlagEntrySourceEnumFromJSONTyped,
  FeatureFlagEntrySourceEnumToJSON,
} from './FeatureFlagEntrySourceEnum';

/**
 *
 * @export
 * @interface FeatureFlagEntry
 */
export interface FeatureFlagEntry {
  /**
   *
   * @type {boolean}
   * @memberof FeatureFlagEntry
   */
  enabled: boolean;
  /**
   *
   * @type {FeatureFlagEntrySourceEnum}
   * @memberof FeatureFlagEntry
   */
  source: FeatureFlagEntrySourceEnum;
  /**
   *
   * @type {string}
   * @memberof FeatureFlagEntry
   */
  description: string;
  /**
   *
   * @type {boolean}
   * @memberof FeatureFlagEntry
   */
  isPublic: boolean;
}

/**
 * Check if a given object implements the FeatureFlagEntry interface.
 */
export function instanceOfFeatureFlagEntry(value: object): value is FeatureFlagEntry {
  if (!('enabled' in value) || value['enabled'] === undefined) return false;
  if (!('source' in value) || value['source'] === undefined) return false;
  if (!('description' in value) || value['description'] === undefined) return false;
  if (!('isPublic' in value) || value['isPublic'] === undefined) return false;
  return true;
}

export function FeatureFlagEntryFromJSON(json: any): FeatureFlagEntry {
  return FeatureFlagEntryFromJSONTyped(json, false);
}

export function FeatureFlagEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeatureFlagEntry {
  if (json == null) {
    return json;
  }
  return {
    enabled: json['enabled'],
    source: FeatureFlagEntrySourceEnumFromJSON(json['source']),
    description: json['description'],
    isPublic: json['is_public'],
  };
}

export function FeatureFlagEntryToJSON(value?: FeatureFlagEntry | null): any {
  if (value == null) {
    return value;
  }
  return {
    enabled: value['enabled'],
    source: FeatureFlagEntrySourceEnumToJSON(value['source']),
    description: value['description'],
    is_public: value['isPublic'],
  };
}
